module.exports = __webpack_public_path__ + "img/u1367.91c8e704.png";